import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { CampaignService } from '@app/_core/services/campaign.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { map } from 'rxjs';
@Component({
  selector: 'app-compose',
  templateUrl: './compose.component.html',
  styleUrl: './compose.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ComposeComponent implements OnInit, OnDestroy {
  // fileInputs: number[] = [0];
  modalRef?: BsModalRef;
  fileInputsToShow: boolean = true;
  fileInputs: { id: number; file: File | null }[] = [];
  nextId: number = 1;
  GetCompositionfromSend: any = [];
  selectedOption: any;
  showTextbox: boolean = false;
  private audio: HTMLAudioElement;
  savingAudioFileMessage: any = '';
  audioFileMessage: any = [];
  audioFileMessageName: any = [];
  to: any;
  from: any;
  headerText: any;
  coverPage: any;
  files: any = [];
  Content: any;
  form!: FormGroup;
  isSubmitted: boolean = false;
  isContentCheck: boolean = false;
  editorContent: any;
  toNumber: any;
  fromNumber: any = '';
  toCheckFileCount: boolean = false;
  selectedTab: any;
  activeTabIndex: number = 0;
  headerTextValue: string = '';
  clientAbbreviation: any;
  sendFaxError: boolean = false;
  sendFaxErrorMessage: string = '';
  FileTypeError: boolean = false;
  FileTypeErrorMessage: string = '';
  sendToComposition = [
    { name: 'Select One', label: 'Select One', type: 1 },
    { name: 'Other', label: 'Other(specify below)', type: 2 },
  ];

  coverPageComposition = [{ name: 'None', label: 'None', type: 1 }];
  getCompositionfromSendTimer: any;
  ngOnInit(): void {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
   // console.log(this.clientAbbreviation);
    this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
    this.GetCompositionData();
    this.selectedOption = { value: '1', label: 'Select one' };
    this.getCompositionfromSendTimer = setTimeout(() => {
      if (this.GetCompositionfromSend && this.GetCompositionfromSend.length > 0) {
        this.fromNumber = this.GetCompositionfromSend[0].label;
       // console.log(this.fromNumber);
      }
    }, 1000);
  }
  constructor(
    private router: Router,
    private campaignService: CampaignService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private queueService: QueuesService,
    private location: Location
  ) {
    this.audio = new Audio();
  }

  addFileInput(event: Event) {
    event.preventDefault();
    this.fileInputs.push({ id: this.nextId++, file: null });
  }
  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
  }

  removeFileInput(id: number) {
    this.fileInputs = this.fileInputs.filter(input => input.id !== id);
  }
  removeFileInputDefault() {
    this.sendFaxErrorMessage = '';
    this.fileInputsToShow = false;
  }
  GetCompositionData() {
    this.queueService.GetCompositionData().subscribe(response => {
     // console.log(response);
      response.Response.Data.SenderNumbers.forEach(element => {
        this.GetCompositionfromSend.push({ label: element.label, value: element.value });
      });
     // console.log(this.GetCompositionfromSend);
    });
  }
  editorContentHandler(content : any) {
    //console.log('editorContentHandler', $event);
    this.editorContent = content;
    //console.log(this.editorContent.length);
  }

  onDropdownChange() {
    const sourceValue = this.selectedOption.value;
    if (sourceValue == 'Other(specify below)') {
      this.showTextbox = true;
    } else {
      this.showTextbox = false;
    }
  }
  handleFileInput(event) {
    this.savingAudioFileMessage = 'Saving File';
    // this.FileTypeError = false;
    // this.FileTypeErrorMessage = '';
    const input = event.target;
    if (!input.files?.length) {
      this.savingAudioFileMessage = '';
      return;
    }
    const file = input.files[0];
    const fileExt = file.name.split('.').pop()?.toLowerCase();
    const mimeType = file.type;

    const allowedExtensions = ['png', 'jpeg', 'jpg', 'pdf', 'txt', 'doc', 'docx'];
    const allowedMimeTypes = [
      'image/png',
      'image/jpeg',
      'application/pdf',
      'text/plain',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    if (!fileExt || !allowedExtensions.includes(fileExt) || !allowedMimeTypes.includes(mimeType)) {
      this.savingAudioFileMessage = '';
      this.sendFaxError = true;
      this.sendFaxErrorMessage = 'Unsupported file type. Please upload PNG, JPEG, PDF, TXT, or Word documents.';
      return;
    } else {
      this.sendFaxErrorMessage = '';
    }

    //const fileExt = event.target.files[0].name.split('.').pop();
    const path = (window.URL || window.webkitURL).createObjectURL(file);
   // console.log('path', path, fileExt);

    this.audioFileMessage.push(file);
    this.audioFileMessageName.push(this.audioFileMessage.join('\n'));

    if (fileExt === 'wav' || fileExt === 'mp3') {
      this.loadAudio(path); // for preview
    }
    // this.campaignService.uploadFile(file, fileExt, false, '').subscribe(response => {
    //   console.log('saveFile', response);
    //   this.savingAudioFileMessage = response.Response.Data.Name;
    // });
  }
  // handleFileInput(event) {
  //   this.savingAudioFileMessage = 'Saving File';
  //   const input = event.target;
  //   if (!input.files?.length) {
  //     this.savingAudioFileMessage = '';
  //     return;
  //   }
  //   const file = input.files[0];
  //   const fileExt = event.target.files[0].name.split('.').pop();
  //   const path = (window.URL || window.webkitURL).createObjectURL(file);
  //   console.log('path', path, fileExt);

  //   this.audioFileMessage.push(file);
  //   this.audioFileMessageName.push(this.audioFileMessage.join('\n'));

  //   if (fileExt === 'wav' || fileExt === 'mp3') {
  //     this.loadAudio(path); // for preview
  //   }
  //   // this.campaignService.uploadFile(file, fileExt, false, '').subscribe(response => {
  //   //   console.log('saveFile', response);
  //   //   this.savingAudioFileMessage = response.Response.Data.Name;
  //   // });
  // }
  loadAudio(audioFilePath) {
   // console.log('loadAudio', audioFilePath);
   // console.log('loadAudio', audioFilePath);
   // console.log(this.audio);
    this.audio.src = audioFilePath;
   // console.log(audioFilePath);
    this.audio.load();
  }

  setSelectedTab(event: any) {
    this.activeTabIndex = event.index;
    //console.log(this.activeTabIndex);
  }
  saveChanges(event: Event, Form: any) {
   // console.log(this.fromNumber);
    event.preventDefault();
    this.isSubmitted = true;
    if (this.showTextbox && !this.toNumber.trim()) {
      return;
    }

    if (this.audioFileMessage.length <= 0 && this.activeTabIndex == 1) {
      this.toCheckFileCount = true;
      return;
    } else {
      this.toCheckFileCount = false;
    }

    if (!this.editorContent && this.activeTabIndex == 0) {
      this.isContentCheck = true;
      return;
    } else {
      this.isContentCheck = false;
    }

    interface data {
      to: string;
      from: string;
      headerText: string;
      coverPage: number;
      files?: string;
      Content?: string;
    }

    const rawContent = this.editorContent ?? '';
    // const tempDiv = document.createElement('div');
    // tempDiv.innerHTML = rawContent;
    // const plainTextContent = tempDiv.textContent?.trim() || '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(rawContent, 'text/html');
    const plainTextContent = doc.body.textContent?.trim() ?? '';

    const data: data = {
      to: this.toNumber,
      from: this.fromNumber,
      headerText: this.headerTextValue,
      coverPage: -1,
      files: this.audioFileMessage,
      Content: plainTextContent,
    };

    if (Form.valid) {
      this.queueService
        .SendFax(data)
        .pipe(
          // map((data: any) => {
          //   const isValid = ResponseHandler.processResponse(data, 'SendFax');
          //   if (isValid) {
          //     this.bsModalRef.hide();
          //     this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
          //   }
          // })
          map((data: any) => {
            const isValid = ResponseHandler.processResponse(data, 'SendFax');
            if (isValid) {
              const responseStatus = data?.Response?.Status;
              const responseMessage = data?.Response?.Message;

              if (responseStatus === 2) {
                this.sendFaxError = true;
                this.sendFaxErrorMessage = responseMessage || 'Send failed. Please try again.';
              } else {
                this.sendFaxError = false;
                this.bsModalRef.hide();
                this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
              }
            }
          })
        )
        .subscribe();
    }
  }
  ngOnDestroy() {
    this.getCompositionfromSendTimer && clearTimeout(this.getCompositionfromSendTimer);
  } 
}
